export default "__VITE_ASSET__DcXRwBdM__"